// Geological, ESG & Rehabilitation Intelligence data — values in ZAR

// ----------------- 1. GEOLOGICAL & RESERVE MAPPING -----------------
// Mining sites with Leaflet-compatible coordinates [lat, lng].
// Polygons are simplified rectangles around each site for illustrative purposes.
export const miningSites = [
  {
    id: "tzaneen",
    name: "Tzaneen Mineral Project",
    region: "Limpopo",
    commodity: "Coal · PGM · Chrome",
    status: "Operational",
    isPrimary: true,
    reserves: "22.4M tons (P+P)",
    grade: "Coal 24 MJ/kg · PGM 3.2 g/t",
    activeAreaHa: 740,
    coords: [-23.83, 30.16],
    boundary: [
      [-23.78, 30.10],
      [-23.78, 30.22],
      [-23.88, 30.22],
      [-23.88, 30.10],
    ],
    drillPoints: [
      { id: "DH-01", lat: -23.81, lng: 30.13, grade: "high",   value: "PGM 4.8 g/t" },
      { id: "DH-02", lat: -23.82, lng: 30.16, grade: "high",   value: "Coal seam 2.4m" },
      { id: "DH-03", lat: -23.83, lng: 30.18, grade: "amber",  value: "PGM 2.6 g/t" },
      { id: "DH-04", lat: -23.85, lng: 30.20, grade: "amber",  value: "Chrome 38% Cr2O3" },
      { id: "DH-05", lat: -23.86, lng: 30.13, grade: "low",    value: "PGM 1.4 g/t" },
      { id: "DH-06", lat: -23.84, lng: 30.21, grade: "low",    value: "Coal seam 0.8m" },
    ],
    gradeZones: [
      { grade: "high",  poly: [[-23.80, 30.12], [-23.80, 30.17], [-23.83, 30.17], [-23.83, 30.12]] },
      { grade: "amber", poly: [[-23.83, 30.12], [-23.83, 30.20], [-23.86, 30.20], [-23.86, 30.12]] },
      { grade: "low",   poly: [[-23.86, 30.12], [-23.86, 30.21], [-23.88, 30.21], [-23.88, 30.12]] },
    ],
  },
  {
    id: "northern-cape",
    name: "Sishen Iron-Copper Block",
    region: "Northern Cape",
    commodity: "Iron Ore · Copper",
    status: "Exploration",
    reserves: "Estimated 180M tons (Inferred)",
    grade: "Fe 64% · Cu 1.8%",
    activeAreaHa: 0,
    coords: [-27.78, 22.99],
    boundary: [
      [-27.70, 22.85],
      [-27.70, 23.15],
      [-27.90, 23.15],
      [-27.90, 22.85],
    ],
    drillPoints: [
      { id: "NC-01", lat: -27.74, lng: 22.92, grade: "high",  value: "Fe 66%" },
      { id: "NC-02", lat: -27.78, lng: 23.00, grade: "high",  value: "Cu 2.1%" },
      { id: "NC-03", lat: -27.82, lng: 23.08, grade: "amber", value: "Fe 58%" },
    ],
    gradeZones: [
      { grade: "high",  poly: [[-27.72, 22.88], [-27.72, 23.03], [-27.80, 23.03], [-27.80, 22.88]] },
      { grade: "amber", poly: [[-27.80, 22.88], [-27.80, 23.12], [-27.88, 23.12], [-27.88, 22.88]] },
    ],
  },
  {
    id: "mpumalanga",
    name: "Witbank Coal Field",
    region: "Mpumalanga",
    commodity: "Thermal Coal",
    status: "Operational",
    reserves: "84M tons (P+P)",
    grade: "27 MJ/kg · 14% ash",
    activeAreaHa: 320,
    coords: [-25.87, 29.23],
    boundary: [
      [-25.80, 29.15],
      [-25.80, 29.32],
      [-25.94, 29.32],
      [-25.94, 29.15],
    ],
    drillPoints: [
      { id: "MP-01", lat: -25.84, lng: 29.18, grade: "high",  value: "Coal seam 4.2m" },
      { id: "MP-02", lat: -25.87, lng: 29.23, grade: "high",  value: "Coal seam 3.6m" },
      { id: "MP-03", lat: -25.90, lng: 29.28, grade: "amber", value: "Coal seam 2.1m" },
      { id: "MP-04", lat: -25.92, lng: 29.30, grade: "low",   value: "Coal seam 0.9m" },
    ],
    gradeZones: [
      { grade: "high",  poly: [[-25.82, 29.16], [-25.82, 29.25], [-25.88, 29.25], [-25.88, 29.16]] },
      { grade: "amber", poly: [[-25.88, 29.16], [-25.88, 29.30], [-25.92, 29.30], [-25.92, 29.16]] },
      { grade: "low",   poly: [[-25.92, 29.16], [-25.92, 29.32], [-25.94, 29.32], [-25.94, 29.16]] },
    ],
  },
  {
    id: "north-west",
    name: "Rustenburg PGM Tenement",
    region: "North West",
    commodity: "Platinum Group Metals",
    status: "Development",
    reserves: "12.4M oz PGM (4E)",
    grade: "4.6 g/t (4E)",
    activeAreaHa: 180,
    coords: [-25.66, 27.24],
    boundary: [
      [-25.58, 27.16],
      [-25.58, 27.34],
      [-25.74, 27.34],
      [-25.74, 27.16],
    ],
    drillPoints: [
      { id: "NW-01", lat: -25.62, lng: 27.20, grade: "high",  value: "PGM 6.1 g/t" },
      { id: "NW-02", lat: -25.66, lng: 27.24, grade: "high",  value: "PGM 5.4 g/t" },
      { id: "NW-03", lat: -25.70, lng: 27.30, grade: "amber", value: "PGM 3.2 g/t" },
    ],
    gradeZones: [
      { grade: "high",  poly: [[-25.60, 27.18], [-25.60, 27.27], [-25.68, 27.27], [-25.68, 27.18]] },
      { grade: "amber", poly: [[-25.68, 27.18], [-25.68, 27.32], [-25.74, 27.32], [-25.74, 27.18]] },
    ],
  },
];

export const gradeColors = {
  high:  { fill: "#DC2626", stroke: "#991B1B", label: "High-grade" },
  amber: { fill: "#D97706", stroke: "#92400E", label: "Moderate" },
  low:   { fill: "#059669", stroke: "#065F46", label: "Lower-grade" },
};

// ----------------- 2. ESG & REHABILITATION -----------------
export const rehabilitation = {
  disturbedHa: 1250,
  rehabilitatedHa: 620,
  outstandingHa: 630,
  progressPct: 49.6,
  closureReadinessPct: 68,
  envScore: 75,
  liabilityProvisionRm: 262,
  rehabGuaranteeRm: 148,
  waterComplianceProvisionRm: 12,
};

export const rehabProgressTrend = [
  { year: "2020", rehabilitatedHa: 380, target: 400 },
  { year: "2021", rehabilitatedHa: 425, target: 450 },
  { year: "2022", rehabilitatedHa: 485, target: 500 },
  { year: "2023", rehabilitatedHa: 555, target: 560 },
  { year: "2024", rehabilitatedHa: 620, target: 620 },
  { year: "2025", rehabilitatedHa: 620, target: 695 }, // YTD
];

export const dmreCompliance = [
  { item: "Annual Rehabilitation Report", status: "green", note: "Submitted Q1 2025" },
  { item: "Closure Financial Provision Audit", status: "green", note: "Independently verified · Standard Bank escrow" },
  { item: "Rehabilitation Guarantee", status: "green", note: "R148m bank guarantee in favour of DMRE" },
  { item: "Mine Closure Plan v3", status: "amber", note: "Submitted · in DMRE review (expected Q3 2025)" },
  { item: "Asbestos & Hazardous Substances Register", status: "green", note: "Updated 2024-12" },
  { item: "Section 24G Post-Rehab Sign-off", status: "amber", note: "Pending for 2 historical pit areas" },
];

// ----------------- 3. SLP TRACKING -----------------
export const slpProjects = [
  { name: "Community Water Project (Tzaneen East)", category: "LED",                budgetRm: 12, completionPct: 80, status: "Active",     beneficiaries: "8,400 households" },
  { name: "Local SME Supplier Development",        category: "Enterprise Dev.",    budgetRm: 8,  completionPct: 65, status: "Active",     beneficiaries: "32 local SMEs" },
  { name: "Skills Training Programme (Artisan)",   category: "Skills Dev.",        budgetRm: 15, completionPct: 92, status: "Active",     beneficiaries: "180 trainees" },
  { name: "Education Infrastructure (3 schools)",  category: "Community",          budgetRm: 6,  completionPct: 45, status: "In Progress", beneficiaries: "1,250 learners" },
  { name: "Healthcare Clinic Upgrade",             category: "Community",          budgetRm: 5,  completionPct: 100, status: "Completed",   beneficiaries: "≈12,000 catchment" },
  { name: "Apprenticeship Pipeline (TVET)",        category: "Skills Dev.",        budgetRm: 9,  completionPct: 25, status: "In Progress", beneficiaries: "60 apprentices/yr" },
];

export const employmentEquity = [
  { metric: "Black ownership",            actualPct: 51, targetPct: 51, status: "green" },
  { metric: "Black women in management",  actualPct: 28, targetPct: 30, status: "amber" },
  { metric: "HDSA in core skills",        actualPct: 64, targetPct: 60, status: "green" },
  { metric: "Disabled employees",         actualPct: 2.1, targetPct: 2.0, status: "green" },
  { metric: "Local Limpopo workforce",    actualPct: 73, targetPct: 70, status: "green" },
];

export const smeParticipation = {
  localProcurementPct: 38,
  bbbeeCompliantSuppliers: 67,
  smesIncubated24mo: 14,
  totalSpendOnSmesRm: 215,
};

// ----------------- 4. ESG & INVESTMENT RISK -----------------
export const esgScores = {
  composite: 78,
  environmental: 72,
  social: 78,
  governance: 85,
  benchmark: "Industry median: E 65 · S 70 · G 76",
};

export const esgRisks = [
  { area: "Carbon emissions disclosure (TCFD)", severity: "amber", note: "Phase 1 disclosure submitted · Phase 2 due 2026" },
  { area: "Tailings Storage Facility audit",    severity: "amber", note: "Independent ICMM review due Q3 2025 · R8m provision" },
  { area: "Community grievance backlog",        severity: "amber", note: "12 open cases · resolution within 90 days target" },
  { area: "Methane fugitive emissions",         severity: "red",   note: "Sensor network deployment delayed · regulatory exposure" },
  { area: "Water-quality monitoring",           severity: "green", note: "All discharge points within DWS limits · audited" },
  { area: "Board diversity",                    severity: "green", note: "44% female · 67% HDSA · exceeds JSE listing standard" },
];

// ----------------- MINE SUSTAINABILITY & READINESS SCORE -----------------
export const readinessComponents = [
  { dimension: "Operations",         score: 87, weight: 0.20, color: "#0F172A" },
  { dimension: "Financial Health",   score: 80, weight: 0.20, color: "#B45309" },
  { dimension: "ESG Compliance",     score: 78, weight: 0.15, color: "#059669" },
  { dimension: "Rehabilitation",     score: 50, weight: 0.15, color: "#7C3AED" },
  { dimension: "SLP Delivery",       score: 76, weight: 0.15, color: "#DC2626" },
  { dimension: "Closure Readiness",  score: 68, weight: 0.15, color: "#1E40AF" },
];

export function computeReadinessScore() {
  const weighted = readinessComponents.reduce((s, c) => s + c.score * c.weight, 0);
  return Math.round(weighted * 10) / 10;
}

export const readinessBands = [
  { min: 80, label: "Investment Ready",          color: "#059669", description: "Strong across all dimensions — institutionally investable today." },
  { min: 65, label: "Growth Opportunity",        color: "#B45309", description: "Solid foundations with identified upside — moderate de-risking required pre-close." },
  { min: 50, label: "Operational Risk",          color: "#D97706", description: "Material gaps in one or more dimensions — buyer should price contingencies." },
  { min: 0,  label: "High Liability Exposure",   color: "#DC2626", description: "Significant rehabilitation, ESG or financial overhang — distressed-asset playbook applies." },
];

export function getReadinessBand(score) {
  return readinessBands.find((b) => score >= b.min) || readinessBands[readinessBands.length - 1];
}
